@if (isHeading) {
  <div class="w-100 d-flex align-items-center header-row details-desktop-only">
    @for (h of columnConfig; track h; let i = $index) {
      <div [style.--col-w]="widths[i] + '%'" class="table-cell heading-cell inner-table-font-size details-desktop-only">
        <p class="text-uppercase m-0 p-0">
          {{
            h.compose
              ? getComposedHeaderText(h, headerPrefix)
              : ('TABLE.HEADINGS.' + headerPrefix + (headerPrefix ? '.' : '') + h.key | translate)
          }}
        </p>
      </div>
    }
  </div>
} @else {
  <div [ngClass]="!isStripedTable ? 'row-wrapper' : ''" class="mx-3 mx-lg-0">
    <div
      [ngClass]="{
        'row-wrapper-body': !isStripedTable,
        active: isOpenDetail,
        light: isLight,
        dark: !isLight,
        shadow: entityType === 'last_final_user'
      }"
    >
      <div
        class="w-100 row-container"
        [class]="!isStripedTable || !isOdd ? cssConfig.table.main : ''"
        [ngClass]="{
          'odd-row': isStripedTable && isOdd,
          light: isLight,
          dark: !isLight,
          'row-container-simple': !isSimple
        }"
      >
        <div class="d-flex align-items-center">
          @for (h of columnConfig; track h; let i = $index) {
            <div
              [style.--col-w]="widths[i] + '%'"
              class="table-cell"
              [ngClass]="{ 'w-100': !h.iconOnly, 'icon-only-cell': h.iconOnly }"
              (mouseenter)="onCellHover(i, true, h)"
              (mouseleave)="onCellHover(i, false, h)"
              role="button"
              (click)="onCellClick(i, h, $event)"
              (keydown.enter)="onCellClick(i, h, $event)"
              tabindex="0"
            >
              <div class="d-flex gap-2 align-items-center position-relative" [ngClass]="h.classlist">
                <p class="m-0 p-0 key-text">
                  {{
                    h.compose
                      ? getComposedHeaderText(h, headerPrefix)
                      : ('TABLE.HEADINGS.' + headerPrefix + (headerPrefix ? '.' : '') + h.key | translate)
                  }}
                </p>
                <div class="value-container gap-1" [class.icon-only]="h.iconOnly">
                  @if (h.key === 'active') {
                    <app-icam-icon [iconName]="values[h.key] ? 'OK' : 'KO'" [isDefault]="true"></app-icam-icon>
                  } @else {
                    @if (h.icon && !h.iconAfter) {
                      @if (h.defaultIcon) {
                        @if (h.defaultIcon === 'user') {
                          <div class="icon-container">
                            <app-icam-icon [iconName]="h.defaultIcon" [isInverted]="true" />
                          </div>
                        } @else if (h.defaultIcon === 'attachment' && containsAttachment) {
                          <app-icam-icon [iconName]="h.defaultIcon" />
                        }
                      } @else if (values[h.key]) {
                        <app-icam-icon [iconName]="iconsMappings[values[h.key]]" [isDefault]="true" />
                      }
                    }
                    @if (h.iconOnly) {
                    } @else if (h.compose) {
                      <p
                        class="m-0 p-0 d-block d-lg-auto text-start"
                        [ngClass]="[entityType === 'machines_performance' ? 'inner-table-font-size' : '']"
                      >
                        <span
                          [class.truncate-singleline]="h.truncate?.singleLine"
                          [style.max-width]="getTruncateMaxChars(h.truncate)"
                          [title]="getComposedCellText(h)"
                        >
                          {{ getComposedCellText(h) }}
                        </span>
                      </p>
                    } @else if (!h.isDate && !h.needsTranslation) {
                      <p
                        class="m-0 p-0 d-block d-lg-auto text-start"
                        [ngClass]="[entityType === 'machines_performance' ? 'inner-table-font-size' : '']"
                      >
                        @if (h.isArray) {
                          <span
                            [appTooltip]="getFullArrayValues(h.key)"
                            position="top"
                            [class.truncate-singleline]="h.truncate?.singleLine"
                            [style.max-width]="getTruncateMaxChars(h.truncate)"
                            [title]="getFullArrayValues(h.key)"
                          >
                            {{ getArrayFieldValues(h.key, h.arrayDisplayType, h.needsTranslation) }}
                          </span>
                        } @else if (isBoolean(values[h.key]) && entityType === 'sales_order_documents') {
                          <span class="gap-2 fw-semibold d-flex align-items-center flex-nowrap">
                            <app-icam-icon [iconName]="values[h.key] ? 'OK' : 'KO'" [isDefault]="true"></app-icam-icon>
                            {{
                              values[h.key]
                                ? ('TABLE.MESSAGES.UPLOADED' | translate)
                                : ('TABLE.MESSAGES.NOT_UPLOADED' | translate)
                            }}
                          </span>
                        } @else if (isBoolean(values[h.key])) {
                          <ng-container>
                            <app-icam-icon [iconName]="values[h.key] ? 'OK' : 'KO'" [isDefault]="true"></app-icam-icon>
                          </ng-container>
                        } @else if (values[h.key]) {
                          <ng-container>
                            <span
                              [class.truncate-singleline]="h.truncate?.singleLine"
                              [style.max-width]="getTruncateMaxChars(h.truncate)"
                              [title]="
                                h.truncate
                                  ? h.isArray
                                    ? getFullArrayValues(h.key)
                                    : values[h.key] || ''
                                  : h.isArray
                                    ? getFullArrayValues(h.key)
                                    : values[h.key] || ''
                              "
                              [appTooltip]="
                                h.truncate
                                  ? h.isArray
                                    ? getFullArrayValues(h.key)
                                    : (values[h.key] | translate)
                                  : null
                              "
                              position="top"
                            >
                              {{ values[h.key] | translate }}
                            </span>
                          </ng-container>
                        } @else if (h.defaultMessaggeIfEmpty) {
                          {{ h.defaultMessaggeIfEmpty | translate }}
                        } @else {
                          {{ 'STATUSES.NOT_AVAILABLE' | translate }}
                        }
                      </p>
                    } @else if (h.needsTranslation) {
                      <p
                        class="m-0 p-0 text-left d-flex align-items-center"
                        [ngClass]="entityType === 'machines_performance' ? 'inner-table-font-size' : ''"
                      >
                        @if (isBoolean(values[h.key])) {
                          <ng-container>
                            {{ (values[h.key] ? 'TABLE.GENERICS.YES' : 'TABLE.GENERICS.NO') | translate }}
                          </ng-container>
                        }
                        @if (h.isArray) {
                          <span
                            [appTooltip]="getFullArrayValues(h.key)"
                            position="top"
                            [class.truncate-singleline]="h.truncate?.singleLine"
                            [style.max-width]="getTruncateMaxChars(h.truncate)"
                            [title]="getFullArrayValues(h.key)"
                          >
                            {{ getArrayFieldValues(h.key, h.arrayDisplayType, h.needsTranslation) }}
                          </span>
                        } @else if (values[h.key]) {
                          <ng-container>
                            {{
                              h.translationPrefix
                                ? (h.translationPrefix + '.' + values[h.key] | translate)
                                : (values[h.key] | translate)
                            }}
                          </ng-container>
                        } @else if (h.defaultMessaggeIfEmpty) {
                          {{ h.defaultMessaggeIfEmpty | translate }}
                        } @else {
                          {{ 'STATUSES.NOT_AVAILABLE' | translate }}
                        }
                      </p>
                    } @else {
                      <p
                        class="m-0 p-0"
                        [ngClass]="entityType === 'machines_performance' ? 'inner-table-font-size' : ''"
                      >
                        @if (values[h.key]) {
                          <ng-container>
                            {{ values[h.key] | date: 'dd/MM/yyyy' }}
                          </ng-container>
                        } @else {
                          -
                        }
                      </p>
                    }
                    @if (h.iconAfter) {
                      @if (h.defaultIcon) {
                        @if (h.defaultIcon === 'attachment' && containsAttachment) {
                          <app-icam-icon [iconName]="h.defaultIcon" />
                        }
                      }
                    }
                  }
                  @if (isUtilsVisible(i, h)) {
                    <div class="cell-utils-popover" (mouseenter)="onPopoverEnter(i)" (mouseleave)="onPopoverLeave(i)">
                      <div class="cell-utils-popover-inner">
                        @for (util of h.utils || []; track util) {
                          <button
                            class="cell-util-btn"
                            type="button"
                            [disabled]="util.disabledWhen?.(values)"
                            (click)="handleUtil(util, values); $event.stopPropagation()"
                            [attr.title]="util.title || ''"
                          >
                            <app-icam-icon [iconName]="util.icon" />
                          </button>
                        }
                      </div>
                      <span class="cell-utils-popover-arrow"></span>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
          @if (isOpenDetail && (entityType === 'requests' || entityType === 'closed_tickets')) {
            <div class="w-100 details-mobile-only">
              <app-table-row-details
                [entityType]="entityType"
                [serialNumber]="serialNumber"
                [resolution]="resolution"
                [description]="description"
                (closeDetails)="openDetails()"
              />
            </div>
          }
          @if (hasButton) {
            <div class="table-cell button-wrapper">
              @if (entityType === 'user' || entityType === 'partner' || entityType === 'banner') {
                <button
                  (click)="handleBtnClick(values)"
                  [ngClass]="[cssConfig.table.buttonShow, isLight ? 'light' : 'dark']"
                >
                  {{
                    hasAdminRole()
                      ? entityType === 'banner'
                        ? ('TABLE.BUTTONS.EDIT_BANNER' | translate)
                        : ('TABLE.BUTTONS.EDIT_USER' | translate)
                      : entityType === 'banner'
                        ? ('TABLE.BUTTONS.VIEW_BANNER' | translate)
                        : ('TABLE.BUTTONS.VIEW_USER' | translate)
                  }}
                </button>
              } @else {
                <div class="d-flex gap-2 align-items-center justify-content-center">
                  <!-- Primary button -->
                  @if (entityType !== 'company_group_user' || shouldShowImpersonateButton()) {
                    <button
                      (click)="handleBtnClick(values)"
                      [ngClass]="[
                        tableConfig.btnAction === 'download'
                          ? cssConfig.table.buttonShow
                          : isOpenDetail
                            ? cssConfig.table.buttonHide
                            : cssConfig.table.buttonShow,
                        isLight ? 'light' : 'dark'
                      ]"
                      [disabled]="shouldDisableImpersonateButton()"
                      [class.disabled]="shouldDisableImpersonateButton()"
                    >
                      @if (tableConfig.btnAction === 'download') {
                        <div class="d-flex align-items-center gap-2">
                          <app-icam-icon iconName="download" [iconHeight]="'14px'" />
                          {{ 'TABLE.BUTTONS.' + entityType + '.download' | translate }}
                        </div>
                      } @else {
                        {{
                          isCurrentUserCompanyGroupRow()
                            ? ('TABLE.BUTTONS.' + entityType + '.connected' | translate)
                            : (isOpenDetail
                              ? 'TABLE.BUTTONS.' + entityType + '.hideDetails'
                              : 'TABLE.BUTTONS.' + entityType + '.showDetails'
                            ) | translate
                        }}
                      }
                    </button>
                  }
                  @if (tableConfig.hasSecondaryButton) {
                    <button
                      (click)="handleSecondaryBtnClick(values)"
                      [ngClass]="[
                        tableConfig.secondaryBtnAction === 'download'
                          ? cssConfig.table.buttonDownload
                          : cssConfig.table.buttonShow,
                        isLight ? 'light' : 'dark'
                      ]"
                      [disabled]="isSecondaryButtonDisabled(values)"
                      [class.disabled]="isSecondaryButtonDisabled(values)"
                    >
                      @if (tableConfig.secondaryBtnAction === 'download') {
                        <div class="d-flex align-items-center gap-2">
                          <app-icam-icon iconName="download" [iconHeight]="'14px'" />
                        </div>
                      } @else {
                        {{ 'TABLE.BUTTONS.' + entityType + '.secondary' | translate }}
                      }
                    </button>
                  }
                  @if (isTertiaryButtonVisible()) {
                    <button
                      (click)="handleTertiaryBtnClick(values)"
                      [ngClass]="[cssConfig.table.buttonDelete || cssConfig.table.buttonShow, isLight ? 'light' : 'dark']"
                      [attr.title]="'TABLE.BUTTONS.' + entityType + '.delete' | translate"
                    >
                      <app-icam-icon iconName="cancel" [iconHeight]="'14px'" />
                    </button>
                  }
                </div>
              }
            </div>
          }
        </div>
        @if (isOpenDetail) {
          <div [ngClass]="entityType === 'requests' || entityType === 'closed_tickets' ? 'w-100 details-desktop-only' : 'd-block w-100'">
            <app-table-row-details
              [entityType]="entityType"
              [serialNumber]="serialNumber"
              [resolution]="resolution"
              [description]="description"
              (closeDetails)="openDetails()"
            />
          </div>
        }
      </div>
    </div>
  </div>
}
